// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PEditOutlinedSvg from "@fishx/icons-svg/es/asn/PEditOutlined";
import FishxIcon from '../components/FishxIcon';

var PEditOutlined = function PEditOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PEditOutlinedSvg
  }));
};

PEditOutlined.displayName = 'PEditOutlined';
export default React.forwardRef(PEditOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PEditOutlined.js
// module id = 3349
// module chunks = 0